module.exports = __webpack_public_path__ + "static/media/pdf.b3bfeb7d.svg";